'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { Award, ArrowRight, X, Quote } from 'lucide-react';
import { GlassCard } from '@/components/ui/glass-card';
export default function CaseStudyBlock() {
  const $ = _c(9);
  const [modalOpen, setModalOpen] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => setModalOpen(true);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="inline-flex items-center gap-2 bg-gradient-to-r from-cyan-500 to-teal-500 rounded-full px-4 py-2 mb-6"><Award className="h-4 w-4 text-white" /><span className="text-sm text-white font-medium">{"Credit & Collections Technology Award Winner"}</span></div>;
    t2 = <h3 className="text-2xl font-bold mb-4 text-white">Recognised Excellence</h3>;
    t3 = <p className="text-white/60 mb-6">Our partnership with NatWest won the prestigious technology award for delivering outstanding customer outcomes.</p>;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <GlassCard className="relative p-8 rounded-[32px] cursor-pointer" variant="strong" onClick={t0}><div className="text-center">{t1}{t2}{t3}<div className="flex items-center justify-center gap-2 text-cyan-400"><span className="text-sm font-medium">View case study</span><ArrowRight className="h-4 w-4" /></div></div></GlassCard>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== modalOpen) {
    t5 = modalOpen && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4" onClick={() => setModalOpen(false)}><div className="absolute inset-0 bg-black/70 backdrop-blur-sm" /><div className="relative w-full max-w-3xl max-h-[85vh] overflow-y-auto glass-strong rounded-2xl border border-cyan-500/20 shadow-2xl animate-in fade-in zoom-in-95 duration-200" onClick={_temp}><div className="sticky top-0 z-10 flex items-start justify-between p-6 pb-4 border-b border-white/10 glass-strong rounded-t-2xl"><div className="flex items-center gap-3"><div className="inline-flex p-2.5 rounded-xl bg-gradient-to-br from-cyan-500 to-teal-500"><Award className="h-5 w-5 text-white" /></div><h2 className="text-xl font-bold text-white">NatWest Group — Case Study</h2></div><button onClick={() => setModalOpen(false)} className="text-white/50 hover:text-white transition-colors p-1"><X className="h-5 w-5" /></button></div><div className="p-6 space-y-8"><ModalSection title="The Challenge"><p className="text-white/70 leading-relaxed">NatWest Group approached Paylink to develop end-to-end digital journeys segmented by product type, such as overdrafts, mortgages and credit cards. NatWest Group wanted these journeys to integrate with its AI chatbot, Cora, to give customers access to tailored outcomes.</p></ModalSection><ModalSection title="The Paylink Solution"><div className="space-y-4"><p className="text-white/70 leading-relaxed">NatWest Group's customers are now able to fully self-serve and securely upload personal information for agents to assess and offer suitable repayment plans. In addition, Embark can identify vulnerable customers so they're offered tailored support.</p><p className="text-white/70 leading-relaxed">The digital journeys allow customers to either request or extend a payment holiday. They can also quickly understand how much they can afford to pay if they wish to resume payments and agree the new repayment amount with the agent.</p><p className="text-white/70 leading-relaxed">When a customer requires further support and assistance, they can be instantly and seamlessly referred to advice partner PayPlan for free debt advice.</p></div></ModalSection><ModalSection title="Industry-Recognised"><p className="text-white/70 leading-relaxed">{"NatWest Group's digital journeys won the Innovation in Collections & Recoveries category at the 2020 Credit & Collections Technology Awards. Judges were impressed with the evidence of great customer feedback and how the journeys provided an excellent response to support customers affected by the pandemic."}</p></ModalSection><ModalSection title="What NatWest Group said"><div className="glass rounded-xl p-5 border border-white/10"><Quote className="h-5 w-5 text-cyan-400 mb-3" /><p className="text-white/70 leading-relaxed italic">The introduction of Paylink Collections is not only efficient, but more importantly allows customers to self-serve if that's their preferred choice, and it can be done out of hours, which is working well for the customer. Introducing CRA and Open Banking makes it easier and quicker for customers to get a full view of their financial statement, which they can also download for future use.</p><p className="text-sm text-white/50 mt-3 font-medium">— Chris Laverick, Head of DMO Supplier Management at NatWest Group</p></div></ModalSection><ModalSection title="What Paylink Solutions said"><div className="glass rounded-xl p-5 border border-white/10"><Quote className="h-5 w-5 text-cyan-400 mb-3" /><p className="text-white/70 leading-relaxed italic">We're delighted the online tool is now being used by NatWest customers and are really proud of being able to help those who often feel too ashamed or embarrassed to seek debt advice. We developed NatWest's solution so customers can access advice 24/7 in a quick and convenient way. This is the start of a great new partnership which will benefit NatWest and its customers through the use of new technology.</p><p className="text-sm text-white/50 mt-3 font-medium">— Susan Rann, CEO of Paylink Solutions</p></div></ModalSection></div></div></div>;
    $[5] = modalOpen;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t5) {
    t6 = <>{t4}{t5}</>;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
}

/* ── Section helper ─────────────────────────────────────────────── */
function _temp(e) {
  return e.stopPropagation();
}
function ModalSection(t0) {
  const $ = _c(6);
  const {
    title,
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="h-1 w-6 rounded-full bg-gradient-to-r from-cyan-400 to-teal-400" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== title) {
    t2 = <h3 className="text-lg font-semibold text-white flex items-center gap-2">{t1}{title}</h3>;
    $[1] = title;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== children || $[4] !== t2) {
    t3 = <div className="space-y-3">{t2}{children}</div>;
    $[3] = children;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}